import type { GuideSection } from './types.js';

export function printGuide(
  allSections: GuideSection[],
  section?: string,
  json?: boolean,
): void {
  const sections = section
    ? allSections.filter((s) => s.slug === section)
    : allSections;

  if (section && sections.length === 0) {
    console.error(
      `Unknown guide section: "${section}". Available: ${allSections.map((s) => s.slug).join(', ')}`,
    );
    process.exit(1);
  }

  if (json) {
    console.log(JSON.stringify(sections, null, 2));
    return;
  }

  for (const s of sections) {
    console.log(`\n${'='.repeat(72)}`);
    console.log(`  ${s.title}`);
    console.log(`${'='.repeat(72)}\n`);
    console.log(s.content);
    console.log('');
  }
}
